import I18n from 'locales'
import { refreshToken } from 'services/auth'

export const authHandler = async (error, callback) => {
  let response = null
  if (error.response.status === 401) {
    await refreshToken()
    response = callback && (await callback())
  }
  return response
}

export const callRequest = (
  request,
  success = null,
  failure = null,
  errorHandler = null,
  final = null,
) => {
  request()
    .then(({ data, status, statusText }) => {
      if (status === 200) {
        success && success(data)
      } else {
        failure && failure()
        window.M.toast({ classes: 'Toast-failure', html: statusText })
      }
    })
    .catch(async err => {
      errorHandler && errorHandler(err)
      if (err && err.response) {
        if (err.response.status === 401) {
          const authHandlerResult = await authHandler(err, () =>
            callRequest(request, success, failure, errorHandler, final),
          )
          if (authHandlerResult) {
            success && success(authHandlerResult)
          } else {
            failure && failure()
          }
        } else if (err.response.status === 403) {
          window.M.toast({
            classes: 'Toast--failure',
            html: 'Você não tem acesso a esse produto!',
          })
        } else {
          window.M.toast({
            html: I18n.t('common.fail'),
            classes: 'Toast--failure',
          })
        }
      }
    })
    .finally(() => {
      final && final()
    })
}
